import { createSlice } from '@reduxjs/toolkit';

const wizardSlice = createSlice({
  name: 'wizard',
  initialState: {
    isShow: true,
    isStart: false,
    isQuit: false,
    isPopup: false,
    gnbPopup: { isPopup: false, name: '' },
    popupName: '',
  },
  reducers: {
    open: state => {
      state.isShow = true;
    },
    close: state => {
      state.isShow = false;
    },
    openQuit: state => {
      state.isQuit = true;
    },
    closeQuit: state => {
      state.isQuit = false;
    },
    startSetup: state => {
      state.isStart = true;
    },
    endSetup: state => {
      state.isStart = false;
    },
    openPopup: state => {
      state.isPopup = true;
    },
    closePopup: state => {
      state.isPopup = false;
    },
    openGnbPopup: (state, { payload: { name } }) => {
      state.gnbPopup.isPopup = true;
      state.gnbPopup.name = name;
    },
    closeGnbPopup: state => {
      state.gnbPopup.isPopup = false;
      state.gnbPopup.name = null;
    },
  },
});

export const {
  open,
  close,
  openQuit,
  closeQuit,
  startSetup,
  endSetup,
  openPopup,
  closePopup,
  openGnbPopup,
  closeGnbPopup,
} = wizardSlice.actions;
export default wizardSlice.reducer;
